import { Box, Typography, useMediaQuery } from "@mui/material";
import React, { useState, useEffect } from "react";
import Header from "../../Components/Common/Header";
import { colors } from "../../theme/theme";
import HomePageSearchBar from "../../Components/Common/HomePageSearchBar";
import ProductCards from "../../Components/Home/ProductCards";
import Footer from "../../Components/Common/Footer";
import BrandLogoSlider from "../../Components/Home/BrandLogoSlider";
import { useDispatch, useSelector } from "react-redux";
import {
  collectionsQuery,
  fetchCollections,
} from "../../redux/slices/collectionsSlice";
import QueryCards from "../../Components/Home/QueryCards";

const HomePage = () => {
  const dispatch = useDispatch();

  const { collections } = useSelector((state) => state.collections);

  const [search, setSearch] = useState("");

  useEffect(() => {
    dispatch(fetchCollections());
  }, []);

  const smallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <Box sx={{ backgroundColor: "#FEFEFE" }}>
      <Header />

      <HomePageSearchBar search={search} setSearch={setSearch} />

      <QueryCards />

      <BrandLogoSlider />

      {collections &&
        collections?.map((collection) => {
          const collectionHeading = collectionsQuery.find(
            (item) => item.query === collection?.query,
          )?.heading;
          return (
            <Box
              sx={{
                borderRadius: "20px",
                backgroundColor: "#fff",
                boxShadow: "-1px -2px 15px 0px #00000012",
                ml: 2,
                mr: smallScreen ? 0 : 2,
                mb: 2,
                overflowX: "hidden",
                position: "relative",
              }}
            >
              <Typography
                sx={{
                  fontFamily: "Poppins-Bold",
                  fontSize: "20px",
                  color: colors.textColor,
                  mx: 2,
                  py: 2,
                  textTransform: "capitalize",
                }}
              >
                {collectionHeading}
              </Typography>

              <ProductCards productData={collection.products || []} />
            </Box>
          );
        })}

      <Footer />
    </Box>
  );
};

export default HomePage;
